<template>
  <div class="no_margin" v-title data-title="login" style="position: relative">
    <img
      style="
        width: 100%;
        min-height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
      "
      src="../assets/Battertimg/PC/bg_login.png"
      alt=""
    />
    <div
      id="LoginCard"
      style="
        position: absolute;
        left: 50%;
        top: 100%;
        transform: translateX(-50%);
        z-index: 999;
      "
      class="log_shadow flex flex_around"
    >
      <div>
        <el-card
          v-if="!islog"
          style="width: 350px; background: #000; border: none"
        >
          <div class="text_left mt_10 mb_20">
            <div class="">
              <img
                style="height: 40px"
                src="../assets/Battertimg/PC/logo1000.png"
                alt=""
              />
            </div>
          </div>
          <table style="margin-bottom: 25px; color: #999">
            <tr>
              <td>
                <el-input
                  prefix-icon="el-icon-s-custom"
                  v-model="form.admin_u"
                  placeholder="Username"
                ></el-input>
              </td>
            </tr>
            <!-- 密码 -->
            <tr>
              <td>
                <el-input
                  class="mt_10 mb_10"
                  prefix-icon="el-icon-unlock"
                  type="password"
                  v-model="form.admin_p"
                  placeholder="Password"
                ></el-input>
              </td>
            </tr>

            <tr>
              <td class="flex mb_10">
                <div class="text_bold">I'm not a robot</div>
                <div>
                  <el-checkbox class="ml_10" v-model="checklog"> </el-checkbox>
                </div>
              </td>
            </tr>
            <!-- 按钮 -->
            <tr>
              <td colspan="2">
                <el-button
                  class="mt_10 w_50"
                  style="
                    width: 300px;
                    color: #fff !important;
                    background-color: #0869b5 !important;
                    border: none;
                    font-weight: bold;
                    font-size: 16px;
                  "
                  @click="logIn"
                  >LOG IN</el-button
                >
              </td>
            </tr>
          </table>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { get, post } from "../assets/api/api";
import { UserLogin } from "../assets/api/request";
export default {
  data() {
    return {
      identifyCodes: "1234567890",
      identifyCode: "",
      code: "", //text框输入的验证码
      checklog: "", //验证是否为机器人
      islog: false,
      token: "",
      email: "",
      // autoplay:false,
      isLogin: false,
      labelPosition: "right",
      form: {
        admin_u: "",
        admin_p: "",
      },
    };
  },

  mounted() {},
  created() {},

  methods: {
    logIn() {
      let _this = this;

      if (_this.checklog !== true) {
        _this.$message("please answer the question");
        return;
      }
      let data = {
        AccountName: _this.form.admin_u,
        Password: _this.form.admin_p,
      };
      post(UserLogin, data).then((res) => {
        if (res.data.code == 200) {
          _this.$message.success("Successful");
          _this.form.admin_p = "";
          this.$store.commit("setToken", res.data.token);
          let date = this.dateFtt("dd/MM/yyyy hh:mm:ss", new Date());

          sessionStorage.setItem("date", date);
          _this.$router.push("/admin/Product");
          _this.$store.commit("setActive", "0");
        } else {
          _this.$message.warning(res.data.msg);
        }
      });
    },
    // 时间
    dateFtt(fmt, date) {
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return fmt;
    },
    // 生成随机验证码
    // randomNum(min, max) {
    //   return Math.floor(Math.random() * (max - min) + min);
    // },

    // refreshCode() {
    //   this.identifyCode = "";
    //   this.makeCode(this.identifyCodes, 4);
    // },
    // makeCode(o, l) {
    //   for (let i = 0; i < l; i++) {
    //     this.identifyCode += this.identifyCodes[
    //       this.randomNum(0, this.identifyCodes.length)
    //     ];
    //   }

    // console.log(this.identifyCode);
    // },
  },
};
</script>

<style scoped lang="scss">
::v-deep.LoginCard .el-input__inner {
  background-color: #000 !important;
  color: #999;
}
::v-deep.LoginCard .el-checkbox {
  color: #999 !important;
}
</style>
<style scoped>
/*验证码样式*/
.code {
  width: 124px;
  height: 31px;
  border: 1px solid rgba(186, 186, 186, 1);
}
.login-code {
  cursor: pointer;
}
.el-checkbox,
.el-checkbox__input {
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
}
</style>
